import { useState, useEffect } from 'react';
import I18n from '@/rI18n';

import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import BookmarkItem from './BookmarkItem';

const BookmarkList = ({
    listBookmark,
    setListBookmark,
    setTaggedBookmarkList,
    setFilteredSuggestions,

    userDetail,
    projectInuseDetail,
    isProjectManager,

    handleAddTagBookmark,
    setOnChangeSubmitData,
    editNameError,
    setEditNameError,
    setIsShowDialogConfirmDuplicateShareBookmark,
    isShowDialogConfirmSubmitData
}) => {

    const [displayOptionBookmark, setDisplayOptionBookmark] = useState('')

    const [displayEditBookmarkName, setDisplayEditBookmarkName] = useState('')
    const [editBookmarkName, setEditBookmarkName] = useState('')

    const [isDisplayProjectBookmark, setIsDisplayProjectBookmark] = useState(true)

    const handleBookmarkByActionType = (actionType, bookmark) => {
        if (!actionType) return;
        switch (actionType) {
            case Constant.BOOKMARK_ACTION.EDIT:
                setDisplayEditBookmarkName(bookmark.id)
                setEditBookmarkName(bookmark.name)

                setTimeout(() => {
                    const inputBookmarkElement = document.querySelector(`.bm-editing-${bookmark.id}`);
                    if (inputBookmarkElement) {
                        inputBookmarkElement.focus();
                        setEditNameError('')
                    }
                }, 0);

                break;
            case Constant.BOOKMARK_ACTION.DELETE:
                if (!bookmark.isCanDelete) return;

                let currentListBookmark = [...listBookmark];
                currentListBookmark = currentListBookmark
                    .filter(b => b.id !== bookmark.id)
                    .map(b => {
                        if (!Utils.isEmptyString(bookmark.defaultBookmark) && b.definition === Constant.BOOKMARK_DEFINITION.SYSTEM) {
                            return {...b, defaultBookmark: ''}
                        }
                        return b
                    })
                setListBookmark(currentListBookmark)

                setTaggedBookmarkList(prev => [...prev.filter(b => b.id !== bookmark.id)])
                setFilteredSuggestions(prev => [...prev.filter(b => b.id !== bookmark.id)])
                setOnChangeSubmitData(prev => {
                    const prefix = Utils.getPrefixOfId(bookmark.id);
                    if (prefix === Constant.BOOKMARK_PREFIX.TEMP) {
                        return {
                            edit: [...prev.edit].map(b => {
                                if (!Utils.isEmptyString(bookmark.defaultBookmark) && b.definition === Constant.BOOKMARK_DEFINITION.SYSTEM) {
                                    return {...b, defaultBookmark: ''}
                                }
                                return b
                            }),
                            addNew: [...prev.addNew.filter(b => b.id !== bookmark.id)]
                        }
                    } else {
                        const editList = [...prev.edit];
                        if (!editList.some(b => b.id === bookmark.id)) {
                            return {
                                ...prev,
                                edit: [...editList, {...bookmark, isDeleted: true}]
                            }
                        }
                        return {
                            ...prev,
                            edit: [...prev.edit.map(b => {
                                if (!Utils.isEmptyString(bookmark.defaultBookmark) && b.definition === Constant.BOOKMARK_DEFINITION.SYSTEM) {
                                    return {...b, defaultBookmark: ''}
                                }
                                if (b.id === bookmark.id) {
                                    return {...b, isDeleted: true}
                                }
                                return b
                            })]
                        }
                    }
                })
                break;
            case Constant.BOOKMARK_ACTION.SHARE:
                const listPublicBookmarkNotMe = listBookmark.filter(b => b.creator !== userDetail.id);
                const isExistBookmarkName = listPublicBookmarkNotMe.some(b => b.name === bookmark.name);
                if (isExistBookmarkName) {
                    setIsShowDialogConfirmDuplicateShareBookmark(true)
                    return;
                }
                
                setListBookmark(prev => [
                    ...prev.map(b => {
                        if (b.id === bookmark.id) {
                            return {
                                ...b,
                                shareRange: projectInuseDetail.id
                            }
                        }
                        return b
                    })
                ])
                setOnChangeSubmitData(prev => {
                    const prefix = Utils.getPrefixOfId(bookmark.id);
                    if (prefix === Constant.BOOKMARK_PREFIX.TEMP) {
                        return {
                            ...prev,
                            addNew: [...prev.addNew.map(b => {
                                if (b.id === bookmark.id) {
                                    return {
                                        ...b,
                                        shareRange: projectInuseDetail.id
                                    }
                                }
                                return b
                            })]
                        }
                    } else {
                        const editList = [...prev.edit];
                        if (!editList.some(b => b.id === bookmark.id)) {
                            return {
                                ...prev,
                                edit: [...editList, {...bookmark, shareRange: projectInuseDetail.id}]
                            }
                        }
                        return {
                            ...prev,
                            edit: [...prev.edit.map(b => {
                                if (b.id === bookmark.id) {
                                    return {
                                        ...b,
                                        shareRange: projectInuseDetail.id
                                    }
                                }
                                return b
                            })]
                        }
                    }
                })
                break;
            case Constant.BOOKMARK_ACTION.UNSHARE:
                if (bookmark.creator !== userDetail.id) { // PM update user's bookmark shareRange to private
                    setListBookmark(prev => [...prev].filter(b => b.id !== bookmark.id))
                    setTaggedBookmarkList(prev => [...prev].filter(b => b.id !== bookmark.id))
                } else {
                    setListBookmark(prev => [
                        ...prev.map(b => {
                            if (b.id === bookmark.id) {
                                return {
                                    ...b,
                                    shareRange: bookmark.creator
                                }
                            }
                            return b
                        })
                    ])
                }
                setOnChangeSubmitData(prev => {
                    const prefix = Utils.getPrefixOfId(bookmark.id);
                    if (prefix === Constant.BOOKMARK_PREFIX.TEMP) {
                        return {
                            ...prev,
                            addNew: [...prev.addNew.map(b => {
                                if (b.id === bookmark.id) {
                                    return {
                                        ...b,
                                        shareRange: bookmark.creator
                                    }
                                }
                                return b
                            })]
                        }
                    } else {
                        const editList = [...prev.edit];
                        if (!editList.some(b => b.id === bookmark.id)) {
                            return {
                                ...prev,
                                edit: [...editList, {...bookmark, shareRange: bookmark.creator}]
                            }
                        }
                        return {
                            ...prev,
                            edit: [...prev.edit.map(b => {
                                if (b.id === bookmark.id) {
                                    return {
                                        ...b,
                                        shareRange: bookmark.creator
                                    }
                                }
                                return b
                            })]
                        }
                    }
                })
                break;
            default:
                break;
        }

        setTimeout(() => {
            setDisplayOptionBookmark('')
        }, 0);
    };

    const handleEditBookmarkName = (editValue) => {
        setEditNameError('')
        if (editValue.length > 100) return;
        setEditBookmarkName(editValue)
    }

    const handleSubmitEditBookmarkName = (editValue, editBookmark) => {
        if (isShowDialogConfirmSubmitData) {
            setDisplayEditBookmarkName('')
            return;
        };

        let editedValue = editValue.trim();

        if (editedValue.length === 0) {
            setEditNameError(I18n.get('MSG_VALIDATE_BOOKMARK_NAME_EMPTY'));
            return
        }

        const isEditingMyBookmark = editBookmark.creator === userDetail.id;
        const isExistedName = isEditingMyBookmark
            ? Utils.getPrefixOfId(editBookmark.shareRange) === Constant.BOOKMARK_PREFIX.USER
                // Edit My bookmark in Private bookmark list
                ? listBookmark
                    .filter(b => b.creator === userDetail.id && b.id !== editBookmark.id)
                    .some(b => b.name === editedValue)
                // Edit My bookmark in Public bookmark list
                : listBookmark
                    .filter(b => b.id !== editBookmark.id)
                    .some(b => b.name === editedValue)
            // PM can edit every user
            : listBookmark.filter(b => b.id !== editBookmark.id).some(b => b.name === editedValue)

        if (isExistedName) {
            setEditNameError(I18n.get('MSG_VALIDATE_BOOKMARK_DUPLICATE'))
            return
        }

        let newBookmark = {
            ...editBookmark,
            name: editedValue
        }
        let newListBookmark = listBookmark.map(b => {
            if (b.id === newBookmark.id) {
                return newBookmark
            }
            return b
        })
        setListBookmark([...newListBookmark])
        setTaggedBookmarkList(prev => [...prev.map(b => {
            if (b.id === editBookmark.id) {
                return {
                    ...editBookmark,
                    name: editedValue
                }
            }
            return b
        })])
        setOnChangeSubmitData(prev => {
            const prefix = Utils.getPrefixOfId(editBookmark.id);
            if (prefix === Constant.BOOKMARK_PREFIX.TEMP) {
                return {
                    ...prev,
                    addNew: [...prev.addNew.map(b => {
                        if (b.id === editBookmark.id) {
                            return {
                                ...b,
                                name: editedValue
                            }
                        }
                        return b
                    })]
                }
            } else {
                const editList = [...prev.edit];
                if (!editList.some(b => b.id === editBookmark.id)) {
                    return {
                        ...prev,
                        edit: [...editList, {...editBookmark, name: editedValue}]
                    }
                }
                return {
                    ...prev,
                    edit: [...prev.edit.map(b => {
                        if (b.id === editBookmark.id) {
                            return {
                                ...b,
                                name: editedValue
                            }
                        }
                        return b
                    })]
                }
            }
        })

        setEditBookmarkName('')
        setDisplayEditBookmarkName('')
    }

    const handleTagBookmark = (bookmark) => {
        handleAddTagBookmark(
            bookmark.name,
            false,
            bookmark.id
        )
    }

    const handleDefaultBookmark = (bookmark) => {
        setListBookmark(prev => [...prev.map(b => {
            if (bookmark.definition === Constant.BOOKMARK_DEFINITION.SYSTEM) {
                if (b.id === bookmark.id) {
                    return {...b, defaultBookmark: ''}
                }
                return {...b, defaultBookmark: ''}
            }

            if (b.id === bookmark.id || b.definition === Constant.BOOKMARK_DEFINITION.SYSTEM) {
                return {...b, defaultBookmark: bookmark.id}
            }
            return {...b, defaultBookmark: ''}
        })])

        setOnChangeSubmitData(prev => {
            let addNewList = [...prev?.addNew]
            let editList = [...prev?.edit]

            const prefix = Utils.getPrefixOfId(bookmark.id);
            if (prefix === Constant.BOOKMARK_PREFIX.TEMP) {
                const isExistedBookmark = addNewList.find(b => b.id === bookmark.id)
                if (isExistedBookmark) {
                    addNewList = addNewList.map(b => {
                        if (b.id === bookmark.id) {
                            return {...b, defaultBookmark: bookmark.id}
                        }
                        return {...b, defaultBookmark: ''}
                    })
                } else {
                    addNewList = [...addNewList, {...bookmark, defaultBookmark: bookmark.id}]
                }
                editList = editList.map(b => {
                    return {
                        ...b,
                        defaultBookmark: b.definition === Constant.BOOKMARK_DEFINITION.SYSTEM ? bookmark.id : ''
                    }
                })
                return {
                    addNew: [...addNewList],
                    edit: [...editList]
                }
            }

            addNewList = addNewList.map(b => ({...b, defaultBookmark: ''}))
            const isExistedBookmark = editList.find(b => b.id === bookmark.id)
            if (!isExistedBookmark) {
                editList = [...editList, {...bookmark}]
            }

            editList = editList.map(b => {
                if (bookmark.definition === Constant.BOOKMARK_DEFINITION.SYSTEM) {
                    if (b.id === bookmark.id) {
                        return {...b, defaultBookmark: ''}
                    }
                    return {...b, defaultBookmark: ''}
                }
    
                if (b.id === bookmark.id || b.definition === Constant.BOOKMARK_DEFINITION.SYSTEM) {
                    return {...b, defaultBookmark: bookmark.id}
                }
                return {...b, defaultBookmark: ''}
            })

            return {
                addNew: [...addNewList],
                edit: [...editList]
            }
        })
    }

    // handle event blur bookmarkActionOption
    useEffect(() => {
        const handleClickOutside = (event) => {
            const bookmarkOptionElement = document.querySelector('.bm-option-visible');
            if (
                bookmarkOptionElement && !bookmarkOptionElement.contains(event.target)
            ) {
                setDisplayOptionBookmark('');
            }
        };

        if (!Utils.isEmptyString(displayOptionBookmark)) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [displayOptionBookmark]);

    // handle validate view/edit(name, share, ...) public bookmark
    useEffect(() => {
        if (
            (projectInuseDetail.type === Constant.PROJECT_TYPE.BASE) ||
            (Utils.isB2CUser(userDetail))
        ) {
            setIsDisplayProjectBookmark(false)
        }
    }, [projectInuseDetail, userDetail])

    return (
        <>
            <div className='private-bookmark'>
                <h4 className="title-bookmark-list">{I18n.get('PRIVATE_BOOKMARK_TAG')}</h4>
                {!Utils.isEmptyArray(listBookmark) && (
                    Utils.sortListBookmarkByNameASC(listBookmark)
                        .filter(bookmark => Utils.getPrefixOfId(bookmark.shareRange) === Constant.BOOKMARK_PREFIX.USER)
                        ?.map(bookmark => (
                            <BookmarkItem
                                bookmark={bookmark}
                                displayEditBookmarkName={displayEditBookmarkName}
                                editBookmarkName={editBookmarkName}
                                handleEditBookmarkName={handleEditBookmarkName}
                                handleSubmitEditBookmarkName={handleSubmitEditBookmarkName}
                                editNameError={editNameError}

                                handleDefaultBookmark={handleDefaultBookmark}
                                handleTagBookmark={handleTagBookmark}
                                handleBookmarkByActionType={handleBookmarkByActionType}

                                displayOptionBookmark={displayOptionBookmark}
                                setDisplayOptionBookmark={setDisplayOptionBookmark}

                                shareRangeType={Constant.BOOKMARK_PREFIX.USER}

                                isDisplayOptionIcon={bookmark.definition !== Constant.BOOKMARK_DEFINITION.SYSTEM}
                                isDisplayProjectBookmark={isDisplayProjectBookmark}
                            />
                        ))
                )}

            </div>
            {(isDisplayProjectBookmark) && (
                <div className='project-bookmark'>
                    <h4 className="title-bookmark-list">{I18n.get('SHARE_BOOKMARK_TAG')}</h4>
                    {!Utils.isEmptyArray(listBookmark) && (
                        Utils.sortListBookmarkByNameASC(listBookmark)
                            .filter(bookmark => Utils.getPrefixOfId(bookmark.shareRange) === Constant.BOOKMARK_PREFIX.PROJECT)
                            ?.map(bookmark => (
                                <BookmarkItem
                                    bookmark={bookmark}
                                    displayEditBookmarkName={displayEditBookmarkName}
                                    editBookmarkName={editBookmarkName}
                                    handleEditBookmarkName={handleEditBookmarkName}
                                    handleSubmitEditBookmarkName={handleSubmitEditBookmarkName}
                                    editNameError={editNameError}

                                    handleDefaultBookmark={handleDefaultBookmark}
                                    handleTagBookmark={handleTagBookmark}
                                    handleBookmarkByActionType={handleBookmarkByActionType}

                                    displayOptionBookmark={displayOptionBookmark}
                                    setDisplayOptionBookmark={setDisplayOptionBookmark}

                                    shareRangeType={Constant.BOOKMARK_PREFIX.PROJECT}

                                    isDisplayOptionIcon={(userDetail.id === bookmark.creator || isProjectManager) && bookmark.definition !== Constant.BOOKMARK_DEFINITION.SYSTEM}
                                />
                            ))
                    )}
                </div>
            )}
        </>
    )
}

export default BookmarkList;
